import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { UserService } from '../services/user.service';
import { SearchService } from '../search/services/search.service';

@Injectable({
	providedIn: 'root'
})
export class TagsService {

	constructor(
		private http: HttpClient,
		private userService: UserService,
		private searchService: SearchService
	) { }

	async getTags(prodid: number, tagfields: string[]): Promise<any> {
		let url = `/aw-server/rest/product/relationship`;
		url += `/tags/${prodid}`;
		url += `/fields/${tagfields.join(',')}`;

		try {
			return await firstValueFrom(this.http.get<any>(url, {}));
		} catch (error) {
			return Promise.reject(error);
		}
	}

	async removeTag(ids: string[], tagField: string, tagValue: string): Promise<any> {
		let url = `/aw-server/rest/product/relationship`;
		url += `/tags/remove/${ids.join(',')}`;

		let payload = [{ field: tagField, name: tagValue }];

		try {
			const response = await firstValueFrom(this.http.post<any>(url, payload));
			return Promise.resolve(true);
		} catch (error) {
			return Promise.reject(error);
		}
	}

	async searchTags(tag: any, omitDocId: number): Promise<any> {
		let pageIndex = 1;
		let pageSize = 100;
		let query = "*";
		let bool = "16";
		let sort = "&SORTBY=aw_rank:DESC";
		let libraries = this.userService.user.properties.awlibraryObjectList.filter((x: any) => { return x.isAvailable }).map((x: any) => { return x.name; });
		// Example criteria = 'title=[rm testme2],rm_record_id=[333]'
		let criteria = tag.tagField + "=[" + tag.value + "]";
		let url = this.searchService.buildSearch(null, null, pageIndex, pageSize, null, query, null, criteria, sort, bool, libraries);

		try {
			const response = await firstValueFrom(this.http.get<any>(url));

			if (!response) {
				throw new Error("Invalid response");
			}

			let results = response["csw:GetRecordsResponse"]?.["csw:SearchResults"];
			if (!results) {
				throw new Error("SearchResults not found in response");
			}

			let records = results.iStoreRecord == null ? [] : (Array.isArray(results.iStoreRecord) ? results.iStoreRecord : [results.iStoreRecord]);

			// Filter out the result for omitDocId
			records = records.filter((r: any) => {
				return !(r.id === omitDocId);
			});

			return records;
		} catch (error) {
			return Promise.reject(error);
		}
	}
}
